
(() => {
  "use strict";

  const SIZE_NAMES = ["size"];
  const COLOR_NAMES = ["color", "colour"];
  const SIZE_ORDER = [
    "XS", "S", "M", "L", "XL", "2XL", "3XL",
    "4XL", "5XL", "6XL"
  ];

  let generation = 0;
  let busy = false;

  function getSection() {
    return document.querySelector(".facest-filters-section");
  }

  function getParams() {
    return new URLSearchParams(location.search);
  }

  function getSelection() {
    const p = getParams();
    return {
      sizes: p.getAll("wv_size"),
      colors: p.getAll("wv_color")
    };
  }

  function getBaseParams() {
    const p = getParams();
    p.delete("wv_size");
    p.delete("wv_color");
    p.delete("page");
    p.delete("section_id");
    return p;
  }

  function getVariantInfo(card) {
    let variants = [];

    try {
      variants = JSON.parse(card.dataset.wvVariants || "[]");
    } catch (e) {
      return [];
    }

    const names = (card.dataset.wvOptionNames || "")
      .split("|")
      .map(s => s.trim().toLowerCase());

    const sizeIndex = names.findIndex(n => SIZE_NAMES.includes(n));
    const colorIndex = names.findIndex(n => COLOR_NAMES.includes(n));

    return variants.map(v => ({
      available: v.available,
      size: sizeIndex >= 0 ? String(v.options[sizeIndex] || "") : "",
      color: colorIndex >= 0 ? String(v.options[colorIndex] || "") : ""
    }));
  }

  function matches(card, sizes, colors) {
    const variants = getVariantInfo(card);

    return variants.some(v => {
      const sizeOK = !sizes.length || sizes.includes(v.size);
      const colorOK = !colors.length || colors.includes(v.color);
      return sizeOK && colorOK;
    });
  }

  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, ch => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    })[ch]);
  }

  function sortSizes(values) {
    return [...values].sort((a, b) => {
      const ai = SIZE_ORDER.indexOf(a.toUpperCase());
      const bi = SIZE_ORDER.indexOf(b.toUpperCase());

      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return a.localeCompare(b, undefined, { numeric: true });
    });
  }

  function makeWidget(title, type, values, selected) {
    if (!values.length) return "";

    const items = values.map(value => {
      const checked = selected.includes(value);
      return `
        <label class="wv-variant-choice">
          <input type="checkbox"
            data-wv-filter="${type}"
            value="${escapeHTML(value)}"
            ${checked ? "checked" : ""}>
          <span>${escapeHTML(value)}</span>
        </label>
      `;
    }).join("");

    return `
      <div class="m-filter--widget wv-variant-widget">
        <h4 class="m-filter--widget-title h5">${title}</h4>
        <div class="wv-variant-options">${items}</div>
      </div>
    `;
  }

  function showStatus(message) {
    const status = document.querySelector("[data-wv-status]");
    if (status) status.textContent = message;
  }

  function updateURL(sizes, colors) {
    const params = getBaseParams();

    sizes.forEach(s => params.append("wv_size", s));
    colors.forEach(c => params.append("wv_color", c));

    const qs = params.toString();

    history.pushState(
      { searchParams: qs },
      "",
      location.pathname + (qs ? "?" + qs : "")
    );
  }

  async function fetchAllCards(section, token) {
    const sectionId = section.dataset.sectionId;
    const params = getBaseParams();
    const firstCards = [
      ...section.querySelectorAll("[data-wv-product]")
    ];

    const grid = section.querySelector("[data-product-container]");
    const pages = Math.max(
      1,
      Number(grid?.dataset.totalPages || 1)
    );

    const all = [...firstCards];

    for (let page = 2; page <= pages; page++) {
      if (token !== generation) return null;

      const p = new URLSearchParams(params);
      p.set("section_id", sectionId);
      p.set("page", String(page));

      const response = await fetch(
        location.pathname + "?" + p.toString()
      );

      if (!response.ok) {
        throw new Error("Collection page " + page + " failed");
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(
        html,
        "text/html"
      );

      const cards = [
        ...doc.querySelectorAll(
          ".facest-filters-section [data-wv-product]"
        )
      ];

      all.push(...cards);
    }

    return all;
  }

  async function initialize() {
    const token = ++generation;
    const section = getSection();

    if (!section || busy) return;

    const grid = section.querySelector("[data-product-container]");
    const wrapper = section.querySelector(".m-filter--wrapper");

    if (!grid || !wrapper) return;

    busy = true;

    let status = section.querySelector("[data-wv-status]");

    if (!status) {
      status = document.createElement("p");
      status.dataset.wvStatus = "";
      status.className = "wv-filter-status";
      grid.parentNode.insertBefore(status, grid);
    }

    showStatus("Loading Size & Color filters...");

    try {
      const cards = await fetchAllCards(section, token);

      if (!cards || token !== generation) return;

      const sizes = new Set();
      const colors = new Set();

      cards.forEach(card => {
        getVariantInfo(card).forEach(v => {
          if (v.size) sizes.add(v.size);
          if (v.color) colors.add(v.color);
        });
      });

      const current = getSelection();

      const oldWidget = wrapper.querySelector(
        "[data-wv-filter-wrapper]"
      );
      if (oldWidget) oldWidget.remove();

      const widget = document.createElement("div");
      widget.dataset.wvFilterWrapper = "";

      widget.innerHTML =
        makeWidget(
          "Size",
          "size",
          sortSizes(sizes),
          current.sizes
        ) +
        makeWidget(
          "Color",
          "color",
          [...colors].sort((a, b) => a.localeCompare(b)),
          current.colors
        );

      wrapper.appendChild(widget);

      const originalCards = [...cards];

      function applyFilters() {
        const selectedSizes = [
          ...widget.querySelectorAll(
            '[data-wv-filter="size"]:checked'
          )
        ].map(el => el.value);

        const selectedColors = [
          ...widget.querySelectorAll(
            '[data-wv-filter="color"]:checked'
          )
        ].map(el => el.value);

        const hasSelection =
          selectedSizes.length || selectedColors.length;

        const visibleCards = hasSelection
          ? originalCards.filter(card =>
              matches(card, selectedSizes, selectedColors)
            )
          : originalCards;

        const fragment = document.createDocumentFragment();

        visibleCards.forEach(card => {
          fragment.appendChild(card);
        });

        grid.replaceChildren(fragment);

        const pagination = section.querySelector(
          ".m-collection--pagination"
        );

        if (pagination) {
          pagination.style.display = "none";
        }

        showStatus(
          visibleCards.length + " products found"
        );

        if (!visibleCards.length) {
          const empty = document.createElement("p");
          empty.className = "wv-filter-empty";
          empty.textContent =
            "No products match your selected Size and Color.";
          grid.appendChild(empty);
        }
      }

      widget.addEventListener("change", () => {
        const selectedSizes = [
          ...widget.querySelectorAll(
            '[data-wv-filter="size"]:checked'
          )
        ].map(el => el.value);

        const selectedColors = [
          ...widget.querySelectorAll(
            '[data-wv-filter="color"]:checked'
          )
        ].map(el => el.value);

        updateURL(selectedSizes, selectedColors);
        applyFilters();
      });

      applyFilters();

    } catch (error) {
      console.error("WOVELCI variant filters:", error);
      showStatus("Could not load Size & Color filters.");
    } finally {
      busy = false;
    }
  }

  function scheduleInit() {
    if (busy) {
      generation++;
      busy = false;
    }
    initialize();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleInit);
  } else {
    scheduleInit();
  }

  document.addEventListener("collection:rerendered", scheduleInit);

  window.addEventListener("popstate", () => {
    setTimeout(scheduleInit, 300);
  });
  
function wvSyncActiveFilters() {
  const params = new URLSearchParams(window.location.search);
  const sizes = params.getAll("wv_size");
  const colors = params.getAll("wv_color");

  const facets = document.querySelector("#ActiveFacets");
  if (!facets) return;

  let holder = document.getElementById("wv-active-facets");

  if (!holder) {
    holder = document.createElement("div");
    holder.id = "wv-active-facets";
    holder.style.cssText =
      "display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin:8px 0;";
    facets.appendChild(holder);
  }

  holder.innerHTML = "";

  function changeFilter(type, value) {
    const p = new URLSearchParams(location.search);
    const remaining = p.getAll(type).filter(v => v !== value);
    p.delete(type);
    remaining.forEach(v => p.append(type, v));

    location.href = location.pathname +
      (p.toString() ? "?" + p.toString() : "");
  }

  function createChip(type, value, label) {
    const chip = document.createElement("button");
    chip.type = "button";
    chip.className = "wv-active-filter-chip";
    chip.textContent = "× " + label + ": " + value;
    chip.addEventListener("click", () => changeFilter(type, value));
    holder.appendChild(chip);
  }

  sizes.forEach(value => createChip("wv_size", value, "Size"));
  colors.forEach(value => createChip("wv_color", value, "Color"));

  if (sizes.length || colors.length) {
    const clear = document.createElement("button");
    clear.type = "button";
    clear.textContent = "Clear All";
    clear.className = "wv-clear-all";
    clear.addEventListener("click", () => {
      location.href = location.pathname;
    });
    holder.appendChild(clear);
  }
}

document.addEventListener("change", event => {
  if (event.target.matches("[data-wv-filter]")) {
    setTimeout(wvSyncActiveFilters, 100);
  }
});

document.addEventListener("collection:rerendered", () => {
  setTimeout(wvSyncActiveFilters, 100);
});

setTimeout(wvSyncActiveFilters, 500);

})();
